import { render, staticRenderFns } from "./tourcategorydetails.vue?vue&type=template&id=7cd684c5&scoped=true&"
import script from "./tourcategorydetails.vue?vue&type=script&lang=js&"
export * from "./tourcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./tourcategorydetails.vue?vue&type=style&index=0&id=7cd684c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd684c5",
  null
  
)

export default component.exports